var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "userinfo userbox",
      attrs: { id: "userinfo" }
    },
    [
      _c("div", { staticClass: "userTitle" }, [
        _vm._v(_vm._s(_vm.$t("AccountInfo")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "userRightSmallBox" }, [
        !_vm.isEditName
          ? _c("div", { staticClass: "info infoBorder" }, [
              _c("div", [
                _c("i", {
                  on: {
                    click: function($event) {
                      return _vm.showEdit(0)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("Nickname")))]),
                _vm._v(
                  "\n        " + _vm._s(_vm.userInfo.NickName) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v(_vm._s(_vm.$t("PhoneNumber")))]),
                _vm._v("\n        " + _vm._s(_vm.userInfo.Mobile) + "\n      ")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isEditName
          ? _c(
              "div",
              { staticClass: "info editInfo" },
              [
                _c("div", { staticClass: "editInfoTitle" }, [
                  _vm._v(_vm._s(_vm.$t("UpdateInfo")))
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "infoForm",
                    attrs: { model: _vm.infoForm, rules: _vm.inforules }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "info_form_item",
                        attrs: { prop: "NickName" }
                      },
                      [
                        _c("div", { staticClass: "info_title" }, [
                          _vm._v(_vm._s(_vm.$t("Nickname")))
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "info_ipt",
                          attrs: { placeholder: _vm.$t("verify.nickname") },
                          on: {
                            input: function($event) {
                              return _vm.setInput("NickName")
                            }
                          },
                          model: {
                            value: _vm.infoForm.NickName,
                            callback: function($$v) {
                              _vm.$set(_vm.infoForm, "NickName", $$v)
                            },
                            expression: "infoForm.NickName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "info_btn_between" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "info_btn",
                            on: {
                              click: function($event) {
                                return _vm.resetForm("infoForm")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Cancel")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "info_btn",
                            attrs: { disabled: _vm.disabled, type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.submitInfoForm("infoForm")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Confirm")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isEditPassword
          ? _c("div", { staticClass: "info infoBorder" }, [
              _c("div", [
                _c("i", {
                  on: {
                    click: function($event) {
                      return _vm.showEdit(1)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("UpdatePassword")))]),
                _vm._v("\n        ****************\n      ")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isEditPassword
          ? _c(
              "div",
              { staticClass: "info editInfo" },
              [
                _c("div", { staticClass: "editInfoTitle" }, [
                  _vm._v(_vm._s(_vm.$t("UpdatePassword")))
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "passwordForm",
                    attrs: { model: _vm.passwordForm, rules: _vm.passwordrules }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "info_form_item",
                        attrs: { prop: "oldpassword" }
                      },
                      [
                        _c("div", { staticClass: "info_title" }, [
                          _vm._v(_vm._s(_vm.$t("CurrentPassword")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-input",
                          {
                            staticClass: "info_ipt",
                            attrs: {
                              type: _vm.flagType,
                              minlength: "6",
                              maxlength: "20",
                              placeholder: _vm.$t("verify.CurrentPassword")
                            },
                            on: {
                              input: function($event) {
                                return _vm.setInput()
                              }
                            },
                            model: {
                              value: _vm.passwordForm.oldpassword,
                              callback: function($$v) {
                                _vm.$set(_vm.passwordForm, "oldpassword", $$v)
                              },
                              expression: "passwordForm.oldpassword"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "showing",
                              class: [_vm.flag == true ? "show" : "noshow"],
                              attrs: { slot: "suffix" },
                              on: {
                                click: function($event) {
                                  return _vm.getFlag()
                                }
                              },
                              slot: "suffix"
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "info_form_item",
                        attrs: { prop: "newpassword" }
                      },
                      [
                        _c("div", { staticClass: "info_title" }, [
                          _vm._v(_vm._s(_vm.$t("NewPassword")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-input",
                          {
                            staticClass: "info_ipt",
                            attrs: {
                              type: _vm.flagType,
                              minlength: "6",
                              maxlength: "20",
                              placeholder: _vm.$t("verify.NewPassword")
                            },
                            on: {
                              input: function($event) {
                                return _vm.setInput()
                              }
                            },
                            model: {
                              value: _vm.passwordForm.newpassword,
                              callback: function($$v) {
                                _vm.$set(_vm.passwordForm, "newpassword", $$v)
                              },
                              expression: "passwordForm.newpassword"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "showing",
                              class: [_vm.flag == true ? "show" : "noshow"],
                              attrs: { slot: "suffix" },
                              on: {
                                click: function($event) {
                                  return _vm.getFlag()
                                }
                              },
                              slot: "suffix"
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "info_form_item",
                        attrs: { prop: "repeatpassword" }
                      },
                      [
                        _c("div", { staticClass: "info_title" }, [
                          _vm._v(_vm._s(_vm.$t("ConfirmNewPassword")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-input",
                          {
                            staticClass: "info_ipt",
                            attrs: {
                              type: _vm.flagType,
                              minlength: "6",
                              maxlength: "20",
                              placeholder: _vm.$t("verify.ConfirmNewPassword")
                            },
                            on: {
                              input: function($event) {
                                return _vm.setInput()
                              }
                            },
                            model: {
                              value: _vm.passwordForm.repeatpassword,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.passwordForm,
                                  "repeatpassword",
                                  $$v
                                )
                              },
                              expression: "passwordForm.repeatpassword"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "showing",
                              class: [_vm.flag == true ? "show" : "noshow"],
                              attrs: { slot: "suffix" },
                              on: {
                                click: function($event) {
                                  return _vm.getFlag()
                                }
                              },
                              slot: "suffix"
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "info_btn_between" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "info_btn",
                            on: {
                              click: function($event) {
                                return _vm.resetForm("passwordForm")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Cancel")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "info_btn",
                            attrs: { disabled: _vm.disabled, type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.submitPasswordForm("passwordForm")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Confirm")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c16459e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c16459e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/info.vue
// module id = null
// module chunks = 